import React from 'react';
import '../../styles/HeroAboutUs.css'; // Import Hero specific CSS
import '../../styles/Fonts.css'; // Import Fonts specific CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome


const AboutUs = () => {
  return (
    <>
      <section id="about" className="py-5 about-page d-flex flex-column align-items-center">
        <div className="overlay"></div>
        <div className="container">
          {/* Privacy Policy Title */}
          <h1 className="text-start mb-4 poppins-semibold" style={{ color: '#0B2849' }}>Privacy Policy</h1>

          {/* Introduction */}
          <p className="poppins-light lh-lg mb-4 text-start">
            At RCS Logistics Philippines, we are dedicated to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal information when you interact with our website or services.
          </p>

          {/* Information We Collect */}
          <h4 className="poppins-medium mb-3 text-start" style={{ color: '#0B2849' }}>1. Information We Collect</h4>
          <p className="poppins-light lh-lg mb-4 text-start">
            We collect both personal and non-personal information:
          </p>
          <ul className="poppins-light text-start lh-lg mb-4">
            <li>Personal Information: This includes your name, email address, phone number, and any other details you provide via contact forms, emails, or direct communication.</li>
            <li>Non-personal Information: This may include your IP address, browser type, operating system, and browsing behavior on our website.</li>
          </ul>

          {/* How We Use Your Information */}
          <h4 className="poppins-medium mb-3 text-start" style={{ color: '#0B2849' }}>2. How We Use Your Information</h4>
          <p className="poppins-light lh-lg mb-4 text-start">
            We use your personal information for the following purposes:
          </p>
          <ul className="poppins-light text-start lh-lg mb-4">
            <li>To communicate with you regarding your inquiries and requests.</li>
            <li>To provide logistics services, updates, and promotions that you have requested.</li>
            <li>To improve our services and enhance user experience on our website.</li>
            <li>To comply with legal obligations and prevent fraudulent activities.</li>
          </ul>

          {/* Data Security */}
          <h4 className="poppins-medium mb-3 text-start" style={{ color: '#0B2849' }}>3. Data Security</h4>
          <p className="poppins-light lh-lg mb-4 text-start">
            We take the security of your data seriously and implement appropriate security measures to protect your personal information from unauthorized access, disclosure, or alteration. However, please note that no method of transmission over the internet or method of electronic storage is 100% secure.
          </p>

          {/* Cookies */}
          <h4 className="poppins-medium mb-3 text-start" style={{ color: '#0B2849' }}>4. Cookies</h4>
          <p className="poppins-light lh-lg mb-4 text-start">
            Our website uses cookies to enhance your browsing experience and gather information about site traffic. You can control cookie preferences through your browser settings, but disabling cookies may affect the functionality of the site.
          </p>

          {/* Sharing of Information */}
          <h4 className="poppins-medium mb-3 text-start" style={{ color: '#0B2849' }}>5. Sharing of Information</h4>
          <p className="poppins-light lh-lg mb-4 text-start">
            We do not sell, trade, or rent your personal information to third parties. However, we may share your data with trusted service providers who assist us in operating our website or conducting our business, as long as they agree to keep your information confidential.
          </p>

          {/* Your Rights */}
          <h4 className="poppins-medium mb-3 text-start" style={{ color: '#0B2849' }}>6. Your Rights</h4>
          <p className="poppins-light lh-lg mb-4 text-start">
            You have the right to request access to the personal information we hold about you, to update or correct your details, or to request that we delete your information. To exercise these rights, please contact us at <a href="mailto:Sales@rcsphil.com" className="designer-link">Sales@rcsphil.com</a>.
          </p>

          {/* Your Consent */}
          <h4 className="poppins-medium mb-3 text-start" style={{ color: '#0B2849' }}>7. Your Consent</h4>
          <p className="poppins-light lh-lg mb-4 text-start">
            By using our website and services, you consent to the collection and use of your personal information as described in this Privacy Policy.
          </p>

          {/* Changes to This Policy */}
          <h4 className="poppins-medium mb-3 text-start" style={{ color: '#0B2849' }}>8. Changes to This Privacy Policy</h4>
          <p className="poppins-light lh-lg mb-4 text-start">
            We reserve the right to modify this Privacy Policy at any time. Changes will be effective immediately upon posting on this page, and we encourage you to review this policy periodically.
          </p>

          {/* Contact Us */}
          <h4 className="poppins-medium mb-3 text-start" style={{ color: '#0B2849' }}>9. Contact Us</h4>
          <p className="poppins-light lh-lg mb-4 text-start">
            If you have any questions or concerns about this Privacy Policy or the handling of your data, please feel free to contact us at <a href="mailto:Sales@rcsphil.com" className="designer-link">Sales@rcsphil.com</a> or call us at <a href="tel:(02)88250200" className="designer-link">(02) 88250200 (HOTLINE)</a>.
          </p>
        </div>
       
      </section>
      </>
  );
};

export default AboutUs;
